import api from '../http-common';

const getOptionsData = () =>
  api.post('/settings/general/get-options-data');

const update = (data) =>
  api.post('/settings/general/update', data);

const edit = () =>
  api.post('/settings/general/edit');

const getFile = (data) =>
  api.post('/settings/get-file', data);

export const GeneralService = {
  getOptionsData,
  update,
  edit,
  getFile
}
